import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_product_types_by_status: { message: "idle" },
};

export const retrieve_product_types_by_status_Slice = createSlice({
 name: "retrieve_product_types_by_status",
 initialState,
 reducers: {
  success_retrieve_product_types_by_status: (state, action) => {
   state.retrieve_product_types_by_status = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_product_types_by_status: (state, action) => {
   state.retrieve_product_types_by_status = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_product_types_by_status: (state) => {
   state.retrieve_product_types_by_status = { status: app_consts.IDLE };
  },
  loading_retrieve_product_types_by_status: (state) => {
   state.retrieve_product_types_by_status = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_product_types_by_status, fail_retrieve_product_types_by_status, reset_retrieve_product_types_by_status, loading_retrieve_product_types_by_status } = retrieve_product_types_by_status_Slice.actions;

export default retrieve_product_types_by_status_Slice.reducer;